import styled from 'styled-components';

const StyledWrapper = styled.div`
    .not-found-row {
        height: 100%;
        font-size: 18px;
        color: #434343;

        h2 {
            color: inherit;
        }

        .anticon {
            font-size: 72px;
        }
    }
`;

export default StyledWrapper;
